const functions =  {
    availableMethods() {
        return [
            'login',
            'logout',
            'forgotPassword',
            'resetPassword',
            'requestOtpForToken',
            'resendAuthorizationCode',
            'exchangeAuthorizationCode',
            'exchangeOtpRequiredToken',
            'me',
        ]
    },

    resendAuthorizationCode(data, cancelKey) {
        const url = `${this.modelName}/resend-authorization-code`

        return this._callApi(url, 'post', data, cancelKey)
    },

    exchangeAuthorizationCode(data, cancelKey) {
        const url = `${this.modelName}/exchange-authorization-code`

        return this._callApi(url, 'post', data, cancelKey)
    },

    exchangeOtpRequiredToken(data, cancelKey) {
        const url = `${this.modelName}/exchange-otp-required-code`

        return this._callApi(url, 'post', data, cancelKey)
    },

    login(email, password, deviceId = null, sudomain = null, cancelKey) {
        const url = `${this.modelName}/login`

        const data = {
            email,
            password,
            device_id: deviceId,
            subdomain: sudomain
        }

        return this._callApi(url, 'post', data, cancelKey)
    },

    requestOtp(cancelKey) {
        const url = `${this.modelName}/request-otp`

        return this._callApi(url, 'post', {},  cancelKey)

    },

    requestOtpForToken(data, cancelKey) {
        const url = `${this.modelName}/request-otp-for-token`

        return this._callApi(url, 'post', data,  cancelKey)

    },

    logout(cancelKey) {
        const url = `${this.modelName}/logout`

        return this._callApi(url, 'post', {}, cancelKey).then(
            () => {
                AuthEloquent.unsetApiRequestToken()
            }
        )

    },

    forgotPassword(email, cancelKey){
        const url = `auth/forgot-password`

        const data = {
            email
        }

        return this._callApi(url, 'post', data, cancelKey)
    },

    resetPassword(
        token,
        email,
        password,
        passwordConfirmation,
        pin,
        pinConfirmation,
        otp,
        deviceId = null,
        cancelKey
    ){
        const url = `auth/reset-password`

        const data = {
            token,
            email,
            password,
            password_confirmation: passwordConfirmation,
            pin,
            pin_confirmation: pinConfirmation,
            device_id: deviceId,
            otp
        }

        return this._callApi(url, 'post', data, cancelKey)
    },

    getFillableAttributes() {
        return new Promise((resolve, reject) => {
            reject('This model do not have attributes')
        })
    },

    getAllAttributes() {
        return new Promise((resolve, reject) => {
            reject('This model do not have attributes')
        })
    }
}

export default functions
